import { PureComponent } from 'react';

// A helper that allows a field to have other "dependent" fields. Any time this
// parent field receives a new value it will reset the value and touched state
// of it's dependent fields. The "dependentFields" props expects an array of
// field names.
function withDependentFields(Component) {
  return class WithDependentFields extends PureComponent {
    componentDidUpdate(prevProps) {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const { value, dependentFields } = this.props;

      // @ts-expect-error TS(2339): Property 'touched' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (dependentFields.length && this.props.touched && prevProps.value !== value) {
        dependentFields.forEach((fieldName) => {
          // @ts-expect-error TS(2339): Property 'setFieldTouched' does not exist on type ... Remove this comment to see the full error message
          this.props.setFieldTouched(fieldName, false, false);
          // @ts-expect-error TS(2339): Property 'setFieldValue' does not exist on type 'R... Remove this comment to see the full error message
          this.props.setFieldValue(fieldName, '', false);
        });
      }
    }

    render() {
      // @ts-expect-error TS(2339): Property 'dependentFields' does not exist on type ... Remove this comment to see the full error message
      const { dependentFields, ...rest } = this.props;
      return <Component {...rest} />;
    }
  };
}

export default withDependentFields;
